import script from "./MiPerfil.vue?vue&type=script&setup=true&lang=js"
export * from "./MiPerfil.vue?vue&type=script&setup=true&lang=js"

import "./MiPerfil.vue?vue&type=style&index=0&id=5bb99736&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bb99736"]])

export default __exports__